module.exports = __webpack_public_path__ + "img/1baf70be2c093a0606ce19c4fcfca22d.6a556055.jpg";